import { ManagerBase, MouseEventResult } from './manager-base';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';

export class PanManager extends ManagerBase {
    private isPanning: boolean = false;
    private lastMouseX: number = 0;
    private lastMouseY: number = 0;

    constructor(levelDesigner: LevelDesignerComponent, canvas: HTMLCanvasElement) {
        super(levelDesigner, canvas);
    }

    public override handleMouseDown(event: MouseEvent): MouseEventResult | undefined {
        if (event.button === 1) { // Middle mouse button
            this.isPanning = true;
            this.lastMouseX = event.clientX;
            this.lastMouseY = event.clientY;
            return { cursor: 'grabbing', stopPropagation: true, redraw: false };
        }
        return undefined;
    }

    public override handleMouseMove(event: MouseEvent): MouseEventResult | undefined {
        if (this.isPanning) {
            const deltaX = event.clientX - this.lastMouseX;
            const deltaY = event.clientY - this.lastMouseY;
            
            // Move the viewport by updating the offsets
            this.levelDesigner.setOffsetX(this.levelDesigner.getOffsetX() + deltaX);
            this.levelDesigner.setOffsetY(this.levelDesigner.getOffsetY() + deltaY);
            
            this.lastMouseX = event.clientX;
            this.lastMouseY = event.clientY;
            
            this.levelDesigner.redraw();
            return { cursor: 'grabbing', stopPropagation: true, redraw: true };
        }
        return undefined;
    }

    public override handleMouseUp(event: MouseEvent): MouseEventResult | undefined {
        if (event.button === 1) { // Middle mouse button
            this.isPanning = false;
            return { cursor: 'default', stopPropagation: true, redraw: false };
        }
        return undefined;
    }

    public OnDraw(): void {
        // No need to draw anything for panning
    }
}
